import { Theme } from '@mui/material';
import { 
    createStyles,
    WithStyles as _WithStyles,
    withStyles as _withStyles,
    StyleRulesCallback
} from '@mui/styles';
import { IBaseTheme } from './themes';
declare module 'csstype' {
    interface Properties {
        '--tree-view-color'?: string;
        '--tree-view-bg-color'?: string;
    }
}

// ---------------- Style ------------------ //

export const styles: StyleRulesCallback<Theme, object> = (_theme : Theme) => {
    let theme = _theme as IBaseTheme;
    return createStyles({

        // ------------------------------- //
        // -------- Login Page ----------- //
        // ------------------------------- //

        login_base: {
            margin: 0,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        },
        login_paper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        login_avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
        },
        login_form: {
            width: '100%',
            marginTop: theme.spacing(1),
        },
        login_submit: {
            margin: theme.spacing(3, 0, 2),
        },
        login_failtext: {
            color: "#ff0000"
        },
        loginLogo: {
            height: 120,
        }

        // ------------------------------- //
        // ------------------------------- //
        // ------------------------------- //
    });
}

// ----------------- Export ----------------- //

export default interface IStyleProps extends _WithStyles<typeof styles> {}
export const withStyles = _withStyles(styles, {withTheme: true});

// ------------------------------------------ //